import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditAdvancedSpecializations = () => {
  return (
    <Edit
      title="Редактиране на ВСД"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      mutationOptions={{ meta: { suffix: "info" } }}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditAdvancedSpecializations;
